import { useEffect } from 'react'
import { messageUtils } from '../utils/commonUtils'

const useAutoClosedAlert = ({ messageType, messageContent }) => {
  useEffect(() => {
    if (messageContent) {
      messageUtils.alert(messageContent, { type: messageType })
    }
  }, [messageType, messageContent])
}

export default useAutoClosedAlert
